<template>
  <section
    class="c4-sig"
    :class="{ nolamp: kind === 'none' }"
    aria-live="polite"
    :data-s="signal.s"
  >
    <span
      v-if="kind === 'three'"
      class="c4-lamp3"
      :data-s="signal.s === 'busy' ? 'sys' : signal.s"
      aria-hidden="true"
    >
      <i></i><i></i><i></i>
    </span>
    <span
      v-else-if="kind === 'one'"
      class="c4-lamp"
      :class="{ ring: ring }"
      :data-s="signal.s"
      aria-hidden="true"
    >
      <svg
        v-if="ring"
        :key="ringKey"
        class="c4-ring"
        viewBox="0 0 100 100"
        :style="{ '--rt': signal.total + 's' }"
      >
        <circle class="bg" cx="50" cy="50" r="45" />
        <circle class="fg" cx="50" cy="50" r="45" />
      </svg>
      <i v-if="signal.spin" class="mdi mdi-cached c4-spin"></i>
      <span v-else-if="signal.num != null" class="c4-lampnum">{{ signal.num }}</span>
      <i v-else class="mdi" :class="signal.icon"></i>
    </span>
    <div>
      <div class="c4-sig-t">{{ signal.title }}</div>
      <div v-if="!(compact && signal.next)" class="c4-sig-s">{{ signal.sub }}</div>
    </div>
    <button v-if="signal.next" type="button" class="c4-btn brand" data-fk="next" @click="$emit('next')">
      {{ tx("sig.next") }}
    </button>
  </section>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenSignal",
  mixins: [canteenV4Text],
  props: {
    // { s: green | red | amber | busy | sys, title, sub, icon, spin, num, total, next }
    signal: { type: Object, required: true },
    // none | one | three
    kind: { type: String, default: "one" },
    compact: { type: Boolean, default: false },
    // mijenja se pri svakoj novoj pauzi, da se prsten pokrene ispočetka
    ringKey: { type: [Number, String], default: 0 },
  },
  computed: {
    ring() {
      return this.signal.total > 0 && (this.signal.s === "red" || this.signal.s === "amber");
    },
  },
};
</script>
